import i18n from 'src/i18n';
import ResponsableInfo from 'src/views/Pages/Dashboard/Supplying/Inventory/Supplying/ResponsableInfo.vue';

const configTable = () => {
    const tableColumns = [
        {
            prop: 'code',
            label: i18n.t('common_words.code'),
            minWidth: 100,
            align: 'center',
            sortable: true,
        },
        {
            prop: 'name',
            label: i18n.t('common_words.name'),
            minWidth: 130,
            sortable: true,
        },
        {
            prop: 'type',
            label: i18n.t('common_words.type'),
            minWidth: 90,
            sortable: true,
        },
        {
            prop: 'responsable_name',
            label: i18n.t('inventory.supplying_manager'),
            minWidth: 200,
            formatter: ResponsableInfo,
            sortable: true
        },
        {
            prop: 'maximum_capacity',
            label: i18n.t('inventory.max_capacity'),
            minWidth: 110,
            align: 'center',
            sortable: true,
        },
        {
            prop: 'supplying_unit.abbreviation',
            label: i18n.t('common_words.symbol'),
            minWidth: 80,
            align: 'center',
            sortable: true,
        },
        {
            prop: 'address',
            label: i18n.t('common_words.address'),
            minWidth: 170,
            sortable: true,
        },
        {
            prop: 'latitude',
            label: i18n.t('common_words.latitude'),
            minWidth: 150,
            show: false,
        },
        {
            prop: 'longitude',
            label: i18n.t('common_words.longitude'),
            minWidth: 150,
            show: false,
        },
        {
            prop: 'altitude',
            label: i18n.t('common_words.altitude'),
            minWidth: 150,
            show: false,
        },
        {
            prop: 'name',
            label: i18n.t('inventory.suppliers'),
            minWidth: 150,
            show: false,
            providers: true,
        },
    ];

    return { tableColumns };
};

export default configTable;